import React from "react";
import { Outlet } from "react-router-dom";
// SystemAlertBanner je v Layout.jsx (parent route), tady ho NEpotřebujeme — jinak se renderuje 2×.
// Navigace manažer sekce je v levém sidebaru (skupina "Manažer", gated owner+manager),
// proto tu horní pruh záložek nemáme (byl duplicitní).

export default function ManagerLayout() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-4 px-4 py-4 sm:space-y-6 sm:px-5 sm:py-6">
      <Outlet />
    </div>
  );
}
